import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { buildCrumbs } from '@/lib/breadcrumbs';

export default function Breadcrumb() {
  const { pathname } = useLocation();
  const crumbs = buildCrumbs(pathname);

  return (
    <nav
      aria-label="Breadcrumb"
      className="border-b border-mcx-mist bg-mcx-white"
      data-testid="breadcrumb"
    >
      <div className="max-w-content mx-auto px-6 py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {crumbs.map((crumb, i) => (
            <li key={crumb.href} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRightIcon className="w-3 h-3 text-mcx-fog flex-shrink-0" />}
              {i === crumbs.length - 1 ? (
                <span className="text-mcx-ink font-medium" aria-current="page">
                  {crumb.label}
                </span>
              ) : (
                <Link
                  to={crumb.href}
                  className="text-mcx-slate hover:text-mcx-signal transition-colors"
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
